module.exports = __webpack_public_path__ + "img/5-1.ba9c81c4.jpg";